import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Wrapper } from "@cinch-nx/shared-ui";
import React from "react";
export var hasComponent = function(componentName, components) {
    return !!components[componentName];
};
export var isValidBlock = function(block) {
    return !!(block === null || block === void 0 ? void 0 : block.component) && !!(block === null || block === void 0 ? void 0 : block._uid);
};
export var ElementFactory = function(block, componentMap, props, componentsWithWrapper) {
    if (!isValidBlock(block)) {
        if (block) {
            console.error("Unable to render malformed block as it is missing the 'component' or '_uid' properties:");
            console.error(block);
        }
        return;
    }
    // component does exist
    if (hasComponent(block.component, componentMap)) {
        if (Array.isArray(componentsWithWrapper) && componentsWithWrapper.includes(block.component)) {
            return /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                children: /*#__PURE__*/ React.createElement(componentMap[block.component], _object_spread({}, block, props))
            }, block._uid);
        }
        return /*#__PURE__*/ React.createElement(componentMap[block.component], _object_spread_props(_object_spread({}, block, props), {
            key: block._uid
        }));
    }
    // component doesn't exist yet
    return /*#__PURE__*/ React.createElement(function() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                "The component `",
                block.component,
                "` has not been created yet."
            ]
        });
    }, {
        key: block._uid
    });
};
var ref;
export var checkNotOverLimit = function(block, limitedItems) {
    return !(limitedItems && block.component && Object.prototype.hasOwnProperty.call(limitedItems, block.component) && ((ref = limitedItems[block.component]--) !== null && ref !== void 0 ? ref : 1) <= 0);
};
